<template>
  <ui-dialog show max-width="542px" :closable="false">
    <template #header>
      <h3>{{ $t("message.mobile.common.addApp") }}</h3>
    </template>
    <template>
      <v-form>
        <v-text-field
          v-model="appName"
          v-validate="{ required: true }"
          required
          :label="
            $t('message.mobile.googlePlay.listings.appAddForm.appName') + ' *'
          "
          data-vv-name="name"
          :error-messages="errors.collect('name')"
        />
        <v-text-field
          v-model="appUrl"
          v-validate="{ required: true }"
          required
          :label="
            $t('message.mobile.googlePlay.listings.appAddForm.googlePlayUrl') +
              ' *'
          "
          data-vv-name="google_play_url"
          :error-messages="errors.collect('google_play_url')"
        />
      </v-form>
    </template>
    <template #actions>
      <div class="actions">
        <ui-button class="actions__btn" color="primary" outlined @click="close">
          {{ $t("message.mobile.common.cancel") }}
        </ui-button>
        <ui-button
          class="actions__btn"
          color="primary"
          :loading="isLoading"
          @click="submit"
        >
          {{ $t("message.mobile.common.addApp") }}
        </ui-button>
      </div>
    </template>
  </ui-dialog>
</template>

<script>
import googlePlayService from "@/services/googlePlay";
export default {
  name: "AddAppDialog",
  props: {
    selectedAccountId: {
      type: Number
    }
  },
  data() {
    return {
      appName: "",
      appUrl: "",
      isLoading: false
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async submit() {
      const isValid = await this.$validator.validate();
      if (!isValid) return;
      const data = {
        name: this.appName,
        google_play_url: this.appUrl,
        account: this.selectedAccountId
      };
      try {
        this.isLoading = true;
        await googlePlayService.createApp(data);
        this.$emit("app-added", this.selectedAccountId);
        this.close();
      } catch (error) {
        Object.entries(error.response.data).forEach(([key, value]) => {
          this.errors.add({
            field: key,
            msg: value[0]
          });
        });
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.actions {
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: $spacing * 4;

  &__btn {
    flex: 1;
  }
}
</style>
